import {DataStatus} from 'platform/components';

import {head, isNil, isNotNil} from 'ramda';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import i18n from '@dms/i18n';

import {useRequiredParams} from 'shared/web';

import {InspectionDetail} from './components/InspectionDetail';

export function RentInspections() {
  const {id: rentalOrderId} = useRequiredParams();
  const {
    data: rentalOrder,
    isLoading: isLoadingRentalOrder,
    isError: isErrorRentalOrder,
  } = useGetRentalOrderQuery({
    rentalOrderId,
  });

  const rentInspectionId = head(rentalOrder?.rentVehicleInspections ?? []);
  const vehicleId = rentalOrder?.rentalVehicleId;

  return (
    <DataStatus
      isLoading={isLoadingRentalOrder}
      isEmpty={isNil(rentInspectionId)}
      emptyMessage={i18n.t('page.rentalOrder.labels.noRentInspection')}
      isError={isErrorRentalOrder}
      minHeight={75}
    >
      {isNotNil(rentInspectionId) && isNotNil(vehicleId) && (
        <InspectionDetail isRent={true} vehicleId={vehicleId} inspectionId={rentInspectionId} />
      )}
    </DataStatus>
  );
}
